// Serif title, optional count, then a rule out to the right edge.

export function SectionHead({
  title,
  count,
  asOf,
}: {
  title: string;
  count?: string | null;
  asOf?: string | null;
}) {
  return (
    <div className="sectionhead">
      <h2>{title}</h2>
      {count ? <span className="n">{count}</span> : null}
      <span className="rule" />
      {asOf ? <span className="asof">{asOf}</span> : null}
    </div>
  );
}
